import { AppSettingsModule } from 'services/settings.provider';
import { DataServiceModule } from 'services/data/data.service';
import { MyAccountServiceModule } from 'services/data/myAccount.service';

import { VerifyEmailReminderModule } from './verifyEmailReminder.component';

export const VerifyEmailReminderServiceModule = angular
    .module('app.components.verifyEmailReminder.verifyEmailReminderService', [
        'ngMaterial',
        AppSettingsModule,
        DataServiceModule,
        MyAccountServiceModule,
        VerifyEmailReminderModule
    ]).service('verifyEmailReminderService', (
        $mdToast,
        dataService,
        settings,
        $interval,
        myAccountService
    ) => {
        let reminderToast = null;
        let checkInterval = null;
        let checkForVerificationInterval = 300000;

        return {
            verifyNewEmail,
            showEmailReminder,
            checkIfEmailVerified,
            initVerifyEmailReminder
        };

        function verifyNewEmail(newUser, oldUser) {
            if (oldUser && newUser.email !== oldUser.email) {
                myAccountService.resendVerification(newUser);
                initVerifyEmailReminder();
            }
        }

        function initVerifyEmailReminder() {
            showEmailReminder();
            startEmailVerifiedCheck();
        }

        function showEmailReminder() {
            show().then(() => {
                stopBackgroundCheck();
            });
        }

        function startEmailVerifiedCheck() {
            checkInterval = $interval(() => {
                checkIfEmailVerified();
            }, checkForVerificationInterval);
        }

        function checkIfEmailVerified() {
            const userPromise = myAccountService.getUser(true);
            userPromise.then((user) => {
                if (user.emailVerified) {
                    hide();
                    stopBackgroundCheck();
                }
            });
        }

        function stopBackgroundCheck() {
            $interval.cancel(checkInterval);
        }

        function show() {
            reminderToast = $mdToast.show({
                hideDelay: 0,
                position: 'top',
                template: '<verify-email-reminder></verify-email-reminder>'
            });
            return reminderToast;
        }

        function hide() {
            $mdToast.hide(reminderToast);
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/verifyEmailReminder/verifyEmailReminder.service.js